import React, {FC} from 'react'

import cn from 'classnames/bind'

import LandingsTitle from 'components/blocks/LandingsTitle'
import PortableBlocks from 'components/blocks/PortableBlocks'
import {Container, Row, Col} from 'components/elements/grid'
import {IW2Content} from 'pages/make-your-w2'

import s from './W2FormContent.module.scss'
const cx = cn.bind(s)

interface IW2FormContentProps {
	className?: string
	content: IW2Content['formContent']
}

/** W2FormContent block component */
const W2FormContent: FC<IW2FormContentProps> = ({className, content}) => {
	const general = content?.items?.general
	const details = content?.items?.details
	const taxes = content?.items?.taxes

	return (
		<div className={cx('wrapper', className)}>
			<Container>
				<LandingsTitle className={s.title} title={content?.title} />
				<Row>
					<Col md={{span: 4}}>
						<div className={cx('general', 'type')}>
							<div className={cx('type__header', 'header')}>
								<h4 className={cx('header__title', 'h3')}>{general?.title}</h4>
							</div>

							<p className={cx('type__subtitle', 'fs-tab')}>{general?.subtitle}</p>
							{general?.list && (
								<PortableBlocks className={cx('type__list')} blockContent={general?.list} />
							)}
						</div>
					</Col>
					<Col md={{span: 8}}>
						<div className={cx('details', 'type')}>
							<div className={cx('type__header', 'header')}>
								<h4 className={cx('header__title', 'h3')}>{details?.title}</h4>
							</div>

							<div className={cx('details__items')}>
								{details?.items?.map((item) => (
									<div className={cx('details__item')} key={item._key}>
										<p className={cx('type__subtitle', 'fs-tab')}>{item.title}</p>
										{item?.list && (
											<PortableBlocks className={cx('type__list')} blockContent={item?.list} />
										)}
									</div>
								))}
							</div>
						</div>
					</Col>
				</Row>
				<div className={cx('taxes', 'type')}>
					<div className={cx('type__header', 'header')}>
						<h4 className={cx('header__title', 'h3')}>{taxes?.title}</h4>
						<p className={cx('')}>{taxes?.description}</p>
					</div>

					<p className={cx('type__subtitle', 'fs-tab')}>{taxes?.subtitle}</p>
					<div className={cx('taxes__items')}>
						{taxes?.items?.map((item) => (
							<div className={cx('taxes__item')} key={item._key}>
								{item?.list && (
									<PortableBlocks className={cx('type__list')} blockContent={item?.list} />
								)}
							</div>
						))}
					</div>
				</div>
			</Container>
		</div>
	)
}

W2FormContent.displayName = 'W2FormContent'

export default W2FormContent
